import React from 'react'

function Google() {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clip-path='url(#clip0_11286_17030)'>
        <path
          d='M19.805 10.2302C19.805 9.55044 19.7499 8.86699 19.6323 8.19824H10.2V12.0491H15.6015C15.3773 13.291 14.6571 14.3897 13.6026 15.0878V17.5864H16.825C18.7174 15.8448 19.805 13.2726 19.805 10.2302Z'
          fill='#4285F4'
        />
        <path
          d='M10.2 20.0008C12.897 20.0008 15.1715 19.1152 16.8287 17.5867L13.6062 15.088C12.7096 15.698 11.5522 16.0434 10.2037 16.0434C7.5948 16.0434 5.38279 14.2833 4.58911 11.917H1.26373V14.4928C2.96133 17.8696 6.41898 20.0008 10.2 20.0008Z'
          fill='#34A853'
        />
        <path
          d='M4.58546 11.9172C4.16657 10.6753 4.16657 9.33044 4.58546 8.08848V5.5127H1.26376C-0.154572 8.33834 -0.154572 11.6674 1.26376 14.493L4.58546 11.9172Z'
          fill='#FBBC04'
        />
        <path
          d='M10.2 3.95805C11.6257 3.936 13.0036 4.47247 14.0361 5.45722L16.8911 2.60218C15.0833 0.904587 12.6839 -0.0287217 10.2 0.000673888C6.41898 0.000673888 2.96133 2.13185 1.26373 5.51234L4.58543 8.08813C5.37544 5.71811 7.59113 3.95805 10.2 3.95805Z'
          fill='#EA4335'
        />
      </g>
      <defs>
        <clipPath id='clip0_11286_17030'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Google
